<template>
  <div id="app">
    <div id="nav">
      <router-link to="hiragana">Hiragana</router-link>
      <router-link to="katakana">Katakana</router-link>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style lang="less" scoped>
@import './styles/variables.less';

#app {
  font-family: 'Alef', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  @media @landscape-tables-phones {
    margin-top: 0px;
  }
}

#nav {
  margin-bottom: 10px;

  @media @landscape-tables-phones {
    margin-bottom: 10px;
  }

  a {
    font-size: 24px;
    text-decoration: none;
    transition: all ease-in .1s;
    color: @dark-gunmetal;

    &.active {
      font-weight: bold;
      color: @bright-turquoise;
    }

    @media @smartphones, @tablets {
      font-size: 16px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue